import { Component } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { NgScrollbar } from 'ngx-scrollbar';

import { IconDirective } from '@coreui/icons-angular';
import {
  ContainerComponent,
  INavData,
  ShadowOnScrollDirective,
  SidebarBrandComponent,
  SidebarComponent,
  SidebarFooterComponent,
  SidebarHeaderComponent,
  SidebarNavComponent,
  SidebarToggleDirective,
  SidebarTogglerDirective
} from '@coreui/angular';

import { DefaultFooterComponent } from './';
import { DefaultHeaderComponent } from './default-header/default-header.component'; // <--- Corrected import path and assuming it's standalone
import { navItems } from './_nav';
import { AuthService } from '../../services/auth.service';

function isOverflown(element: HTMLElement) {
  return (
    element.scrollHeight > element.clientHeight ||
    element.scrollWidth > element.clientWidth
  );
}

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.scss'],
  standalone: true,
  imports: [
    SidebarComponent,
    SidebarHeaderComponent,
    SidebarBrandComponent,
    RouterLink,
    IconDirective,
    NgScrollbar,
    SidebarNavComponent,
    SidebarFooterComponent,
    SidebarToggleDirective,
    SidebarTogglerDirective,
    DefaultHeaderComponent, // <--- Now correctly imported as a standalone component
    ShadowOnScrollDirective,
    ContainerComponent,
    RouterOutlet,
    DefaultFooterComponent
  ]
})
export class DefaultLayoutComponent {
  public navItems = navItems;

  onScrollbarUpdate($event: any) {
    // if ($event.verticalUsed) {
    // console.log('verticalUsed', $event.verticalUsed);
    // }
  }

  filteredNavItems: INavData[] = [];

  constructor(private authService: AuthService) {
    this.filterNavItems();
  }

  // Filter navigation items based on user roles
  private async filterNavItems() {
    try {
      const userRoles = await this.authService.getUserRoles();
      this.filteredNavItems = navItems.filter(item => {
        // Show item if no roles are specified
        if (!item.roles) return true;
        
        // Check if user has at least one required role
        return item.roles.some((role: string) => userRoles.includes(role));
      });
    } catch (error) {
      console.error('Error filtering navigation items:', error);
      this.filteredNavItems = [];
    }
  }
}